import React, { useEffect, useContext, useState, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  getSystemSettings,
  toastObj,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import './stock.css'

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";

const SaleInvoiceAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const {id} = useParams();
  const {roundOffStock, qtyAmountPoints} = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    getIngredientItem,
    ingredientItemForSearch,
    dataPaginating,
  } = useContext(RestaurantContext);
  let { getCustomer, customerForSearch, authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);
  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    customer: null,
    description: "",
    transportation: 0,
    paymentType: "cash",
    total: null,
    item_tax: 0,
    paid: null,
    paid_amount: "",
    invoice: "",
    //ref_doc_identity: null,
    //is_ref_no: 0,
  });
  //new Row
  const [newRow,setNewRow]=useState([]);
  
  //datepicker
  const [purchaseDate, setPurchaseDate] = useState(new Date());

  const piDiscountFixed = useMemo(()=>{
    return parseInt(getSystemSettings(generalSettings, "pi_discount")) === 1
  },[generalSettings]);
  
  const piTaxFixed = useMemo(()=>{
    return parseInt(getSystemSettings(generalSettings, "pi_tax")) === 1
  },[generalSettings]);

  //Get Specific item for edit
  const getPurchasedItem = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/sale-invoice/" + parseInt(id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });        
        if(res){
          const editPurchase= res.data;
          if(editPurchase && editPurchase !== null){
            let docDate=new Date(editPurchase.document_date);
            let customer={
              id: editPurchase.customer_id,
              name: editPurchase.customer_name
            };
           
            setNewItem({
              ...newItem,
              invoice:editPurchase.document_identity,
              branch: editPurchase.branch,
              customer,
              paymentType:editPurchase.payment_type,
              description:editPurchase?.desc ?? "",
              paid_amount:editPurchase.paid_amount ?? "",
            })
            setPurchaseDate(docDate);
            let rowArr=[];
            if(editPurchase.sale_invoice_detail && editPurchase.sale_invoice_detail.length > 0){
              editPurchase.sale_invoice_detail.map((item)=>{
                rowArr.push({
                  item_id: item.ingredient_id,
                  item_name: item.ingredient_name,
                  qty:item.qty,
                  unitId:item.unit_id,
                  unit:item.unit_name,
                  price: roundOffStock(item.rate),
                  amount: roundOffStock(item.amount),
                  discount_percent: roundOffStock(item.discount_percent),
                  discount: roundOffStock(item.discount),
                  tax_percent: roundOffStock(item.tax_percent),
                  tax: roundOffStock(item.tax), 
                  total: roundOffStock(item.total),
                  base_unit:item.base_unit,
                  base_qty: roundOffStock(item.base_qty),
                  conversion_qty: roundOffStock(item.conversion_qty),
                  base_price: roundOffStock(item.base_price),
                  isEdit:true,
                })
              })
              setNewRow([...rowArr]);
            }
          }
        }         
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };
      
  //useEffect == componentDidMount()
  useEffect(() => {
    if(!customerForSearch){
      getCustomer();
    }
    if(!ingredientItemForSearch){
      getIngredientItem()
    }

  }, []);
      
  useEffect(()=>{
    if(id){
      getPurchasedItem();
    }
   
  },[customerForSearch,branchForSearch])

  //on change input field
  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //set items hook
  const handleSetItems = async (index,item) => {
    newRow[index].unit="";
    newRow[index].base_unit="";
    newRow[index].base_qty="";
    newRow[index].conversion_qty="";
    newRow[index].item_name=item;
    newRow[index].base_unit=item.unit_id;
    newRow[index].item_units="";
    newRow[index].price= Number(item.price) || 0;
    setNewRow([...newRow]);
    getUnits(item.id,index)
  };

  const getUnits=async(id,index)=>{
    const url = BASE_URL + "/settings/get-unit_item/"+ id;
    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
    .then((res) => {      
      if(res.data){        
        newRow[index].item_units = res.data;
        newRow[index].unit= res.data[1] ?? "";
        newRow[index].conversion_qty= res.data[1]?.qty ?? "";
        setNewRow([...newRow]);
      }      
    }).catch((error) =>{
      console.log("check error",error);
    })
  }

  const handleSetUnit=(index,unit)=>{    
    newRow[index].unit=unit;
    newRow[index].conversion_qty=unit.qty;
    setNewRow([...newRow]);
  }

  const calBaseQty=(index)=>{
    let qty=newRow[index].qty;
    let conversion_qty=newRow[index].conversion_qty
    if(qty && conversion_qty){
      return roundOffStock(qty * conversion_qty);
    }else{
      return "";
    }
  }

  const calBasePrice=(index)=>{
    let amount = handleGetAmount(index);
    let baseQty = calBaseQty(index);
    if(amount && baseQty){
      return roundOffStock(amount/baseQty);
    }else{
      return 0;
    }
  }
  
  const addNewRow=()=>{ 
    setNewRow((pre)=>[...pre,{
      item_name:"",
      ref_doc_identity: "",
      qty:"",
      unit:"",
      price:"",
      amount:"",
      discount_percent:"",
      discount:0,
      tax_percent:"",
      tax:0, 
      total:"",
      base_unit:"",
      base_qty:"",
      conversion_qty:"",
      isEdit:false,
    }])    
  }

  const delRow=(id)=>{
    let row=[...newRow]
    row.splice(id, 1);
    setNewRow(row);
  }

  //subtotal
  const handleGetSubTotal = (index) => {
    let qty = 0;
    let price = 0;
    let tax = 0;
    let discount = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }
    if (newRow !== null && (newRow[index]?.tax || newRow[index]?.tax_percent)) {
      tax = piTaxFixed ? (Number(newRow[index].tax) || 0) : handleTaxItem(index);
    }
    if (newRow !== null && (newRow[index].discount_percent || newRow[index].discount)) {
      discount = piDiscountFixed ? (Number(newRow[index].discount) || 0) : handleDiscountItem(index);
    } 
    return roundOffStock(
      price * qty +  tax - discount
    );
  };

  // discount
  const handleDiscountItem = (index) => {
    let discount = 0;
    let price = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].discount_percent) {
      discount = parseFloat(newRow[index].discount_percent);
    }
    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }
    return roundOffStock(price * qty * (discount / 100));
  };

  const handleDiscounPercent = (index) => {
    let discount = 0;
    let price = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }

    if (newRow !== null && newRow[index].discount) {
      discount = parseFloat(newRow[index].discount);
    }
    return price && qty ? roundOffStock((discount / (price * qty)) * 100) : 0;
  };

  const handleTaxItem = (index) => {
    let tax = 0;
    let price = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].tax_percent) {
      tax = parseFloat(newRow[index].tax_percent);
    }

    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }
    return roundOffStock(price * qty * (tax / 100));
  };

  const handleTaxPercent = (index) => {
    let tax = 0;
    let price = 0;
    let qty = 0;

    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }

    if (newRow !== null && newRow[index].tax) {
      tax = parseFloat(newRow[index].tax);
    }

    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }
    return price && qty ? roundOffStock((tax / (price * qty)) * 100) : 0;
  };

  const handleDisAmount = () => {
    let discount = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        if(piDiscountFixed){
          if(item.discount){
            discount = discount + Number(item.discount);
          }
        }else{
          if (item.discount_percent) {
            discount = discount +
              item.price *
                item.qty *
                (item.discount_percent / 100);
          }
        }
      });
    }   
    return roundOffStock(discount);
  };

  const handleTaxAmount = () => {
    let tax = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        if(piTaxFixed){
          if(item?.tax){
            tax = tax + Number(item.tax);
          }
        }else{
          if (item.tax_percent) {
            tax = tax +
              item.price * item.qty *
              (item.tax_percent / 100);
          }
        }
      });
    }
    return roundOffStock(tax);
  };

  // total amount
  const handleAmount = () => {
    let total = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {        
        if (
          parseFloat(item.qty) && parseFloat(item.price)
        ) {
          total = total +  parseFloat(item.qty) * parseFloat(item.price);
        }
      });
    }
    return roundOffStock(total);
  };

  //total
  const handleGetTotal = () => {
    let total = 0;
    let tax = 0;
    let discount = 0;
    if (newRow !== null && newRow.length>0) {
      newRow.map((item) => {
        tax = 0;
        discount = 0;
        if(piTaxFixed){
          if(item.tax){
            tax = Number(item.tax);
          }
        }else{
          if (item.tax_percent) {
            tax = item.price *
              item.qty *
              (item.tax_percent / 100);
          }
        }
        if(piDiscountFixed){
          if (item.discount) {
            discount = Number(item.discount);
          }
        }else{
          if (item.discount_percent) {
            discount = item.price *
            item.qty * (item.discount_percent / 100);
          }
        }
        if (
          parseFloat(item.qty) && parseFloat(item.price)
        ) {          
          total =
            total + (item.qty * item.price) + tax - discount;
        }
      });
    }
    return roundOffStock(total);
  };

  //subtotal
  const handleGetAmount = (index) => {
    let qty = 0;
    let price = 0;
    if (newRow !== null && newRow[index].qty) {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].price) {
      price = parseFloat(newRow[index].price);
    }
    return roundOffStock(price * qty);
  };

  //set each item qty
  const handleItemQty = (index,e) => {
    newRow[index].qty=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleItemRate = (index,e) => {
    newRow[index].price=e.target.value;
    setNewRow([...newRow]);
  };

   //discount and tax
   const handleSetRow = (index,e, key) => {
    newRow[index][key]=e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch });
  };

  //handle Set customer hook
  const handleSetCustomer = (customer) => {
    setNewItem({ ...newItem, customer });
  };

  //post req of food item add
  const ingredientItemAxios = async () => {    
    let date =
      new Date(purchaseDate).getFullYear() +
      "-" +
      (new Date(purchaseDate).getMonth() + 1) +
      "-" +
      new Date(purchaseDate).getDate();

    let slugArray=[];
    newRow.map((newIngredientItem,index) => {
      if(newIngredientItem.item_name === "" || newIngredientItem.unit===""){
        toast.error(`${_t(t("Please select all dropdowns"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      }
      else{
        slugArray.push({
          qty: parseFloat(newIngredientItem.qty),
          price: parseFloat(newIngredientItem.price),
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,          
          unit_id: newIngredientItem.isEdit ? newIngredientItem.unitId : newIngredientItem.unit.id,
          unit_name: newIngredientItem.isEdit ? newIngredientItem.unit : newIngredientItem.unit.name,
          amount: handleGetAmount(index),
          discount_percent: piDiscountFixed ? handleDiscounPercent(index) : (newIngredientItem.discount_percent !== "" ? parseFloat(newIngredientItem.discount_percent) : 0),
          discount: piDiscountFixed ? (newIngredientItem.discount || 0) : handleDiscountItem(index),
          tax_percent: piTaxFixed ? handleTaxPercent(index) : (newIngredientItem.tax_percent !== "" ? parseFloat(newIngredientItem.tax_percent) : 0),
          tax: piTaxFixed ? (newIngredientItem.tax || 0) : handleTaxItem(index),
          total: handleGetSubTotal(index),
          base_unit: newIngredientItem.base_unit,
          base_qty: calBaseQty(index),
          conversion_qty: parseFloat(newIngredientItem.conversion_qty),
          base_price: calBasePrice(index)
        });
      }
      });

    let formData = {
      id: id,
      invoice_number: newItem.invoice,
      branch_id: newItem.branch.id,
      customer_id: newItem.customer.id,   
      customer_name: newItem.customer?.name || "",     
      document_date: date,
      desc: newItem.description,
      paid_amount: newItem.paid_amount,
      payment_type: newItem.paymentType,
      items: slugArray,
      total_bill: handleGetTotal(),
      total_amount: handleAmount(),
      total_tax: handleTaxAmount(),
      total_discount: handleDisAmount(),
    };

    if(newRow.length === slugArray.length){
      setLoading(true);
      const endPoint = id ? "/settings/sale-invoice/" + id : "/settings/sale-invoice";
      const url = BASE_URL + endPoint;
      const mehtod = id ? "put": "post"
      
    try {
      const res = await axios[mehtod](url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLoading(false);
        toast.success(`${_t(t(id ? "Sales invoice has been updated" : "Sales invoice has been created"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/stock/sale-invoice");
      }
    } catch (error) {
      console.log("check error==>",error);
      setLoading(false);
      if(error.response.data.status === 0){
        toast.error(error.response.data.message ,toastObj)
        return false;
      }
      toast.error(`${_t(t("Please try again later"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.customer !== null &&
      newItem.invoice !== null &&
      newItem.paymentType !== null &&
      purchaseDate !== null
    ) {
      if(newRow.length > 0){
        ingredientItemAxios();
      }
      else{
        toast.error(`${_t(t("Please add invoices"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all the required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  return (
  <>
      <Helmet>
        <title>{_t(t(`${id ? "Edit Purchase" : "Add Purchase"}`))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t(`${id ? "Edit Sales Invoice" : "Add Sales Invoice"}`))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">

                            <div className="row">
                              <div className="form-group col-3 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="invoice"
                                    className="control-label"
                                  >
                                    {_t(t("Invoice"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="invoice"
                                    name="invoice"
                                    onChange={handleChange}
                                    value={newItem.invoice}
                                    placeholder="Auto no"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group col-3 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="saleDate"
                                    className="control-label"
                                  >
                                    {_t(t("Sale Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    minDate={authUserInfo?.details?.user_type !== "superAdmin" && new Date()}
                                    disabled={id}
                                    selected={purchaseDate}
                                    onChange={(date) => setPurchaseDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Sale date"))}
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-3 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="paymentType"
                                    className="control-label"
                                  >
                                    {_t(t("Payment Type"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div
                                  className="mb-2 d-flex align-items-center"
                                  style={{ height: "2rem"}}
                                >
                                  <div className="col-6 d-flex align-items-center">
                                    <input
                                      style={{fontSize:"1.2rem"}}
                                      type="radio"
                                      className="form-check-input pointer-cursor table-text"
                                      id="cash"
                                      name="paymentType"
                                      value="cash"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      checked={
                                        newItem.paymentType === "cash" ? 1 : 0
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 mt-2"
                                      htmlFor="cash"
                                      style={{fontSize:"0.9rem"}}
                                    >
                                      {_t(t("Cash"))}
                                    </label>
                                  </div>
                                  <div className="col-6 d-flex align-items-center">
                                    <input
                                      style={{fontSize:"1.2rem"}}
                                      type="radio"
                                      className="form-check-input pointer-cursor table-text"
                                      id="credit"
                                      name="paymentType"
                                      value="credit"
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      checked={
                                        newItem.paymentType === "credit" ? 1 : 0
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 mt-2"
                                      htmlFor="credit"
                                      style={{fontSize:"0.9rem"}}
                                    >
                                      {_t(t("Credit"))}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Branch"))}
                                    <span className="text-danger">*</span>                                      
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.branch || ""}
                                  isDisabled={id}
                                  classNamePrefix="select"
                                  onChange={handleSetBranch}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select a branch")) + ".."
                                  }
                                />
                              </div>  

                            </div>

                            <div className="row">                              

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("Customer"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={customerForSearch ? customerForSearch : []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.customer || ""}
                                  isDisabled={id}
                                  classNamePrefix="select"
                                  onChange={handleSetCustomer}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={
                                    _t(t("Please select customer")) + ".."
                                  }
                                />
                              </div> 

                              <div className="form-group mt-2 col-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="paid_amount"
                                    className="control-label"
                                  >
                                    {_t(t("Paid Amount"))}
                                  </label>
                                </div>

                                <div className="mb-2">
                                  <input
                                    type="number"
                                    className="form-control table-text"
                                    onKeyDown={(evt) =>
                                      ["e", "E", "+", "-","ArrowUp","ArrowDown",].includes(evt.key) &&
                                      evt.preventDefault()
                                    }
                                    max={handleGetTotal()}
                                    onWheel={(e) => e.target.blur()}
                                    id="paid_amount"
                                    name="paid_amount"
                                    onChange={handleChange}
                                    value={newItem.paid_amount}
                                  />
                                </div> 
                              </div>

                              <div className="form-group mt-2 col-6">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Description"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <textarea
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={handleChange}
                                    value={newItem.description}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            
                            </div> 
                            
                            <div className={`table-responsive mt-3 pr-1 `}
                              style={{maxHeight:"23rem",overflow: "auto"}}>
                                <table className="table table-bordered-sm table-hover">
                                  <thead className="align-middle">                                    
                                    <tr>
                                    {newRow.length==0 ?<th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={()=>addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                      </span>
                                    </th>:<th style={{borderBottomColor:"lightgray"}}></th>}
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border table-Child"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Item Name"))}
                                        </span>
                                      </th>                                     
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Unit"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Price"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:'130px'}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Discount Percent"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{minWidth:'130px'}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Discount Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Tax Percent"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Tax Amount"))}
                                        </span>
                                      </th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Total"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border d-none"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base unit"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border d-none"
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base qty"))}
                                        </span>
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border d-none"
                                        style={{minWidth:"9rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Conversion unit"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border d-none"
                                        style={{minWidth:"9rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Base price"))}
                                        </span>
                                      </th>
                                      {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                    </tr>
                                  </thead>
                                  {newRow && newRow.length>0 ?
                                  <tbody className="align-middle">
                                    {newRow.map(
                                      (ingredientItem, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                              {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                            <i className="fa fa-plus-circle btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                            </span>}&nbsp;
                                            <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} 
                                            onClick={()=>{delRow(index)}}
                                            ></i>
                                            </td>
                                            <td className="table-text text-capitalize align-middle text-center">
                                            {ingredientItem.isEdit ?
                                              <input
                                              readOnly
                                              type="text"
                                              className={`form-control text-center table-Input table-text`}
                                              value={ingredientItem.item_name || ""}
                                              />
                                              : 
                                              <Select
                                                options={ingredientItemForSearch !== null ? ingredientItemForSearch : []}
                                                components={makeAnimated()}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                classNamePrefix="select"
                                                onChange={(e)=>handleSetItems(index,e)}
                                                maxMenuHeight="12.8rem"                                                
                                                value={ingredientItem.item_name}
                                                styles={customStyle}
                                                isMenuOpen={true}
                                                menuPlacement={index >= 1 ? "top" : "bottom"} 
                                                menuPosition="fixed"
                                                className="bank-table-input"                                              
                                                placeholder={
                                                _t(t("Please select items")) + ".."
                                                }                                                
                                              />}
                                            </td>
                                          
                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e)=>handleItemQty(index,e)}
                                                value={                                                    
                                                  ingredientItem.qty || ""
                                                }
                                                placeholder="Qty"
                                                required                                                  
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {ingredientItem.isEdit ?
                                              <input
                                                readOnly
                                                type="text"
                                                className={`form-control text-center table-Input table-text`}
                                                value={ingredientItem.unit || ""}
                                              /> 
                                              :                                                
                                              <Select
                                                menuPosition="fixed"
                                                menuPlacement={index >= 1 ? "top" : "bottom"} 
                                                options={ingredientItem.item_units ? ingredientItem.item_units : []}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                value={ingredientItem.unit}
                                                classNamePrefix="select"
                                                onChange={(e)=>handleSetUnit(index,e)}
                                                className="bank-table-input"
                                                maxMenuHeight="200px"
                                                styles={customStyle}                                                  
                                                placeholder={
                                                _t(t("please select unit")) + ".."
                                                }            
                                                isDisabled={ingredientItem.item_units?false:true}                                        
                                              />}
                                            </td>
                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={ingredientItem.id}
                                                name={ingredientItem.id}
                                                onChange={(e)=>handleItemRate(index,e)}
                                                value={                                                  
                                                  ingredientItem.price || ""
                                                }
                                                placeholder="Price"
                                                required                                                 
                                              />
                                            </td>
                                            <td className="table-text align-middle text-center">
                                              {formatPrice(
                                                handleGetAmount(                                                    
                                                  index
                                                )
                                              )}
                                            </td>

                                            {
                                              piDiscountFixed ? (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleDiscounPercent(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"discount")}
                                                      value={                                                    
                                                        ingredientItem.discount || ""
                                                      }
                                                      placeholder="Discount"
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                  
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"discount_percent")}
                                                      value={                                                    
                                                        ingredientItem.discount_percent || ""
                                                      }
                                                      placeholder="Discount"
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleDiscountItem(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>
                                                </>
                                              )
                                            }

                                            {piTaxFixed ? (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {
                                                    formatPrice(handleTaxPercent(index))
                                                    }
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"tax")}
                                                      value={                                                    
                                                        ingredientItem.tax || ""
                                                      }
                                                      placeholder="Tax"
                                                    />
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    <input
                                                      type="number"
                                                      step={qtyAmountPoints()}
                                                      min="0"
                                                      onKeyDown={(evt) =>
                                                        ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                        evt.preventDefault()
                                                      }
                                                      onWheel={(e) => e.target.blur()}
                                                      className={`form-control text-center table-Input table-text ${                                                    
                                                        ""
                                                      }`}
                                                      id={ingredientItem.id}
                                                      name={ingredientItem.id}
                                                      onChange={(e)=>handleSetRow(index,e,"tax_percent")}
                                                      value={                                                    
                                                        ingredientItem.tax_percent || ""
                                                      }
                                                      placeholder="Tax"
                                                    />
                                                  </td>

                                                  <td className="table-text text-capitalize align-middle text-center">
                                                    {formatPrice(
                                                      handleTaxItem(                                                    
                                                        index
                                                      )
                                                    )}
                                                  </td>
                                                </>
                                              )
                                            }

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {formatPrice(
                                                handleGetSubTotal(                                                    
                                                  index
                                                )
                                              )}
                                            </td>

                                            {/* hidden columns */}
                                            
                                            <td className="table-text align-middle text-center d-none">
                                              {ingredientItem.base_unit}
                                            </td> 
                                            
                                            <td className="table-text align-middle text-center d-none">                                                
                                              {formatPrice(calBaseQty(index))}
                                            </td>
                                            
                                            <td className="table-text align-middle text-center d-none">
                                              {ingredientItem.conversion_qty}
                                            </td> 

                                            <td className="table-text align-middle text-center d-none">
                                              {formatPrice(calBasePrice(index))}
                                            </td> 
                                            
                                            <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"60px"}}>
                                              <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(index)}}></i>&nbsp;
                                              {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                                <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                              </span>}                                             
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  :null}
                                  {newRow && newRow.length>0 ?
                                  <tfoot className="align-middle">
                                    <tr>
                                      <th
                                        scope="col"
                                        colSpan="1"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        colSpan="3"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                            {_t(t("Total"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleAmount())}
                                        </span>
                                      </th>
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleDisAmount())}
                                        </span>
                                      </th>
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {formatPrice(handleTaxAmount())}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>                                            
                                          {formatPrice(handleGetTotal())}
                                        </span>
                                      </th>

                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                      
                                      <th                                      
                                        scope="col"                                        
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>
                                    </tr>
                                    {/* <tr>
                                      <th colSpan="1"></th>
                                      <th colSpan="8"></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {_t(t("Transport"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <input
                                          type="number"
                                          step={qtyAmountPoints()}
                                          min="0"
                                          onKeyDown={(evt) =>
                                            ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                            evt.preventDefault()
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          className="form-control text-center table-Input table-text"
                                          id="transportation"
                                          name="transportation"
                                          onChange={(e)=>handleChange(e)}
                                          value={                                                   
                                            newItem.transportation || ""
                                          }
                                        />
                                        </th>
                                        <th colSpan="3"></th>
                                        <th colSpan="1"></th>
                                    </tr>
                                    <tr>
                                      <th colSpan="1"></th>
                                      <th colSpan="8"></th>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>
                                          {_t(t("Net Total"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{fontWeight:"bold"}}>                                            
                                          {formatPrice(handleGetTotal() + (Number(newItem.transportation) || 0))}
                                        </span>
                                      </th>
                                      <th colSpan="3"></th>
                                      <th colSpan="1"></th>
                                    </tr> */}
                                  </tfoot>
                                  :null}
                                </table>
                            </div>

                            <div className="form-group mt-4 pb-2">
                              {/* <div className="col-lg-12">
                                <button
                                  className="btn btn-primary px-5 rounded"
                                  type="submit"                                  
                                >
                                  {_t(t("Save"))}
                                </button>
                                <button
                                  className="btn btn-primary px-5 mx-2 rounded"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/purchase-invoice"
                                    )
                                  }
                                >
                                  {_t(t("Back"))}
                                </button>
                              </div> */}
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={()=>(history.push("/dashboard/manage/stock/sale-invoice"))}
                                  //   data-dismiss="modal"
                                  >
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                  >
                                    <i className="fa fa-floppy-o" aria-hidden="true"></i> {_t(t(`${id ? "Update" : "Save" }`))}
                                  </button>                                                    
                                </div>                                                    
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default SaleInvoiceAction;
